export const DELAY = 300;
export const MAX_WAIT = 1000;
